"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Renders a placeholder until the node is near the viewport, then an img.
 * Avoids Next/React injecting unused <link rel="preload"> for below-fold photos.
 */
const DeferredImage = ({ src, alt = "", className, style, onError, ...props }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!src) return undefined;
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setShow(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: "240px 0px" }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [src]);

  if (!src) return null;

  if (!show) {
    return <div ref={ref} className={className} style={style} aria-hidden />;
  }

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      decoding="async"
      onError={onError}
      {...props}
    />
  );
};

export default DeferredImage;
